export default "__VITE_ASSET__BH$zHDuz__"